import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { currentVisit, error } from '../store/state';
import { ensureVisitLoaded, posponerVisita } from '../store/actions/visit.actions';
import { Shell } from '../layout/Shell';
import { fmt } from '../utils/format';

interface Props {
  id: string;
}

export function PosponerFormView({ id }: Props) {
  useEffect(() => {
    ensureVisitLoaded(id);
  }, [id]);

  const v = currentVisit.value;
  if (!v) return <Shell tab="agenda">{null}</Shell>;

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    try {
      await posponerVisita(v.id, String(fd.get('motivo')), String(fd.get('dias')));
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="agenda">
      <h2>Posponer visita</h2>
      <div class="card">
        <strong>{v.client?.nombre}</strong>
        <p class="muted">Programada: {fmt(v.fechaProgramada)}</p>
      </div>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>Motivo</label>
        <textarea name="motivo" placeholder="Ej: Cliente de vacaciones" required />
        <label>Posponer cuántos días</label>
        <input name="dias" type="number" defaultValue={7} min={1} required />
        <button class="primary" type="submit">
          Posponer
        </button>
        <button class="secondary" type="button" onClick={() => route(`/visitas/${v.id}`)}>
          Cancelar
        </button>
      </form>
    </Shell>
  );
}
